import { render } from "./TenantsGrid.vue?vue&type=template&id=4b9fd672&scoped=true&ts=true"
import script from "./TenantsGrid.vue?vue&type=script&lang=ts"
export * from "./TenantsGrid.vue?vue&type=script&lang=ts"

import "./TenantsGrid.vue?vue&type=style&index=0&id=4b9fd672&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9fd672"]])

export default __exports__